export const LucidLinkLogoTestIdFactory = {
    getLucidLinkLogoBase: () => 'lucidlink-logo',
    getLucidLinkLogoTestId: (testId) => [LucidLinkLogoTestIdFactory.getLucidLinkLogoBase(), testId].join('-'),
};
